module.exports = __webpack_public_path__ + "static/img/giraLogo.5a87476.png";